module.exports = __webpack_public_path__ + "static/media/corona1.206286fb.jpeg";